import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import auth from './auth'

var app = createApp(App)

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add(faArrowLeft)

auth.useRouter(router)
app.use(router)
app.use(auth)
app.component('font-awesome-icon', FontAwesomeIcon)
app.mount('#app')
